export const KEY_FAVORITES = 'favorites'
